// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"LegacyLayout_sectionWrapper__2w0UD"};